import { createRouterLinks } from "@/models/router";
import { RouteConfig } from "vue-router";
import { REmployerCompany, REmployerCompanyMember } from "./views/Company/REmployerCompany";
import { REmployerEmployees } from "./views/Employees/REmployerEmployees";
import { REmployerGuide } from "./views/Guide/REmployerGuide";
// import { REmployerHome } from "./views/Home/REmployerHome";
import { REmployerCompliance } from "./views/Compliance/REmployerCompliance";
import { REmployerHomeNew } from "./views/HomeNew/REmployerHome";
// import { REmployerServices } from "./views/Services/REmployerServices";
// import { REmployerCandidates } from "@/pages/Layout/views/Employer/views/Candidates/REmployerCandidates";
import { REmployerCandidateInvite } from "@/pages/Layout/views/Employer/views/CandidateInvite/RCandidateInvite";
import { REmployerRoles } from "@/pages/Layout/views/Employer/views/Roles/REmployerRoles";
import { REmployerTeammates } from "@/pages/Layout/views/Employer/views/Teammates/REmployerTeammates";
import { REmployerTasks } from "./views/Tasks/REmployerTasks";
// TODO: refactor naming for "Select a candidate for the new visa application"
import { REmployerAccount } from "@/pages/Layout/views/Employer/views/MyAccount/REmployerAccount";
import { REmployerNotifications } from "@/pages/Layout/views/Employer/views/Notifications/REmployerNotifications";
import { REmployerPricing } from "@/pages/Layout/views/Employer/views/Pricing/REmployerPricing";
import { REmployerServicesCandidatesNew } from "@/pages/Layout/views/Employer/views/ServicesCandidatesNew/REmployerServicesCandidates";
import { REmployerServicesExtension } from "@/pages/Layout/views/Employer/views/ServicesExtension/REmployerServicesExtension";
import { REmployerVisaCases } from "@/pages/Layout/views/Employer/views/VisaCases/REmployerVisaCases";
// import { REmployerCopilot } from "@/pages/Layout/views/Employer/views/Copilot/REmployerCopilot";
// import { REmployerServicesPortal } from "@/pages/Layout/views/Employer/views/ServicesPortal/REmployerServicesPortal";

export const REmployer: RouteConfig = {
  path: "employer",
  component: () =>
    import(
      /* webpackChunkName: "employer" */
      "./VEmployer.vue"
    ),
  children: [
    {
      path: "",
      redirect: REmployerHomeNew.path,
    },
    REmployerHomeNew,
    REmployerCompliance,
    REmployerTasks,
    REmployerEmployees,
    // REmployerCandidates,
    // REmployerServices,
    REmployerVisaCases,
    REmployerRoles,
    REmployerCompany,
    REmployerGuide,
    REmployerCandidateInvite,
    REmployerServicesCandidatesNew,
    REmployerAccount,
    REmployerTeammates,
    REmployerPricing,
    REmployerNotifications,
    // REmployerCopilot,
    // REmployerServicesPortal,
    // hidden
    REmployerServicesExtension,
  ],
};

export const employerLinks = createRouterLinks(REmployer);

export const REmployerMember: RouteConfig = {
  path: "employer",
  component: () =>
    import(
      /* webpackChunkName: "employer-member" */
      "./VEmployer.vue"
    ),
  children: [
    {
      path: "",
      redirect: REmployerHomeNew.path,
    },
    REmployerHomeNew,
    REmployerCompliance,
    REmployerTasks,
    REmployerEmployees,
    // REmployerCandidates,
    // REmployerServices,
    REmployerVisaCases,
    REmployerRoles,
    REmployerCompanyMember,
    REmployerGuide,
    REmployerCandidateInvite,
    REmployerPricing,
    REmployerNotifications,
    REmployerServicesCandidatesNew,
    // REmployerCopilot,
    // REmployerServicesPortal,
    // hidden
    REmployerServicesExtension,
  ],
};

export const employerLinksMember = createRouterLinks(REmployerMember);

export const REmployerNoSponsor: RouteConfig = {
  path: "employer",
  component: () =>
    import(
      /* webpackChunkName: "employer-member" */
      "./VEmployer.vue"
    ),
  children: [
    {
      path: "",
      redirect: REmployerHomeNew.path,
    },
    REmployerHomeNew,
    REmployerCompliance,
    // REmployerCandidates,
    // REmployerServices,
    REmployerEmployees,
    REmployerVisaCases,
    REmployerRoles,
    REmployerCompany,
    REmployerGuide,
    REmployerCandidateInvite,
    REmployerPricing,
    REmployerNotifications,
    REmployerServicesCandidatesNew,
    // REmployerCopilot,
    // REmployerServicesPortal,
    // hidden
    REmployerServicesExtension,
  ],
};

export const employerLinksNoSponsor = createRouterLinks(REmployerNoSponsor);
